// import store from '_root/store'
import sessionService from '@/app/services/common/sessionService';
import config from '_config';
// test if user is logged
export default (to, from, next) => {
  const user = sessionService.getLocalData('_user');

  if (user.settings.user_type_id !== config.RESELLER_TYPE_ID) {
    next();
  } else {
    next('/admin/overview');
  }
};
